import getAPI from './getAPI.js'

export default async function getSharepointLibraries(siteId) {
    const data = await getAPI(`admin/sharepoint/libraries/${siteId}`);
    return data;
}
